<template lang="pug">
  b-popover(:target="popoverTarget" triggers="hover focus")
    template(slot="title")
      h5 {{ thisComplaint.comment }}
      small.complaint-status-wrapper(:class="`status-${statuses[thisComplaint.aasm_state].initials.toLowerCase()}`") {{ statuses[thisComplaint.aasm_state].description }}
    p {{ thisComplaint.description | truncateDescription }}
</template>

<script>
import constants from '@/constants/Status.constants';

export default {
  props: ['thisComplaint', 'popoverTarget'],
  data() {
    return {
      statuses: { ...constants.STATUSES, ...constants.STATUSES_ECOMMERCE },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/PopoverDetail.vue